import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const FAQ = () => {
  return (
    <div className="gybtc-container">
      <header className="gybtc-header scrolled">
        <div className="gybtc-header-content">
          <div className="gybtc-logo-container">
            <img
              src="/gybtc-logo.png"
              alt="Grow Your BTC Logo"
              className="gybtc-logo"
            />
          </div>

          <nav className="gybtc-nav">
            <Link to="/" className="gybtc-nav-link">Home</Link>
            <Link to="/privacy" className="gybtc-nav-link">Privacy</Link>
            <Link to="/terms" className="gybtc-nav-link">Terms</Link>
            <Link to="/disclaimer" className="gybtc-nav-link">Disclaimer</Link>
            <a href="/book" className="gybtc-btn-nav-cta">Book 1:1</a>
          </nav>
        </div>
      </header>

      <section className="gybtc-about" style={{ paddingTop: "140px", minHeight: "100vh" }}>
        <div className="gybtc-section-header">
          <h1 className="gybtc-section-title">FAQ</h1>
        </div>

        <div className="gybtc-about-grid" style={{ gridTemplateColumns: "1fr" }}>
          <div className="gybtc-about-card">
            <h3 className="gybtc-about-card-title">Is this financial advice?</h3>
            <p className="gybtc-about-card-text">
              No. Grow Your BTC provides education and general guidance only.
            </p>

            <h3 className="gybtc-about-card-title">Do you custody my Bitcoin?</h3>
            <p className="gybtc-about-card-text">
              No. The goal is education, security, and helping you understand best practices.
            </p>

            <h3 className="gybtc-about-card-title">Who is this for?</h3>
            <p className="gybtc-about-card-text">
              Beginners, long-term savers, and people who want simple guidance on Bitcoin,
              self-custody, privacy, and security.
            </p>

            <h3 className="gybtc-about-card-title">Do you help with wallets and self-custody?</h3>
            <p className="gybtc-about-card-text">
              Yes — from an educational perspective, including setup guidance and security
              best practices.
            </p>

            <h3 className="gybtc-about-card-title">Do you offer 1:1 support?</h3>
            <p className="gybtc-about-card-text">
              Yes. You can book a 1:1 session through the site.
            </p>

            <h3 className="gybtc-about-card-title">What happens after I book?</h3>
            <p className="gybtc-about-card-text">
              You’ll receive the relevant instructions, next steps, and session details.
            </p>

            <h3 className="gybtc-about-card-title">Do you help complete beginners?</h3>
            <p className="gybtc-about-card-text">
              Yes. The goal is to make Bitcoin simple, practical, and understandable.
            </p>

            <h3 className="gybtc-about-card-title">Do you support only Bitcoin?</h3>
            <p className="gybtc-about-card-text">
              Grow Your BTC is Bitcoin-first and focused on long-term education, security, and
              conviction around Bitcoin specifically.
            </p>
          </div>
        </div>
      </section>

      <footer id="footer" className="gybtc-footer">
        <div className="gybtc-footer-content">
          <p className="gybtc-footer-text">
            © 2025 Grow Your BTC • <Link to="/privacy">Privacy Policy</Link> •{" "}
            <Link to="/terms">Terms</Link> • <Link to="/disclaimer">Disclaimer</Link> •{" "}
            <Link to="/faq">FAQ</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default FAQ;
